<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Manage Guest Pass</h4>
    <button type="button" class="close" aria-label="Close"
            (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">

    <p>
      Status: <b>{{ getGuestPassStatusDisplay(guestPass.status) }}</b>
    </p>

    <p>
      Owner:
      <a [routerLink]="'/customers/' + guestPass.owner_id.toString()"
         target="_blank">
        {{ guestPass.owner_first_name }} {{ guestPass.owner_last_name }}
      </a>

      <br>

      <span *ngIf="guestPass.status === GuestPassStatus.used">
        Recipient:
      </span>
      <span *ngIf="guestPass.status !== GuestPassStatus.used">
        Assignee:
      </span>
      <span *ngIf="!guestPass.assignee_id" class="text-muted">None</span>
      <a *ngIf="guestPass.assignee_id"
         [routerLink]="'/customers/' + guestPass.assignee_id.toString()"
         target="_blank">
        {{ guestPass.assignee_first_name }} {{ guestPass.assignee_last_name }}
      </a>
    </p>

    <p>
      Can be used by:
      <b>{{ getGuestPassEligibilityDisplay(guestPass.eligibility, orgConfigService.getLapsedGuestPassWindowMonths()) }}</b>
    </p>

    <p>
      <ng-container *ngIf="guestPass.available_starting_at_date">
        Available on:
        <b>{{ dateStringFromISO8601(guestPass.available_starting_at_date) }}</b>
        <br>
      </ng-container>

      Expires:
      <b *ngIf="guestPass.expires_at_date">
        End of {{ dateStringFromISO8601(guestPass.expires_at_date) }}
      </b>
      <b *ngIf="!guestPass.expires_at_date">Never</b>

      <ng-container *ngIf="guestPass.used_at_date">
        <br>
        Used on:
        <b>{{ dateStringFromISO8601(guestPass.used_at_date) }}</b>
      </ng-container>
    </p>

    <p>
      Name:
      <b *ngIf="guestPass.name">{{ guestPass.name }}</b>
      <span *ngIf="!guestPass.name" class="text-muted">None</span>

      <ng-container *ngIf="guestPass.granting_membership_type_name">
        <br>
        Granting membership:
        <b>{{ guestPass.granting_membership_type_name }}</b>
      </ng-container>

      <ng-container *ngIf="guestPass.granting_user_id">
        <br>
        Created by:
        <b>
          {{ guestPass.granting_user_first_name }}
          {{ guestPass.granting_user_last_name }}
        </b>
      </ng-container>
    </p>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger"
            *ngIf="!loadingSubmit && [GuestPassStatus.notYetAvailable, GuestPassStatus.available, GuestPassStatus.assigned].includes(guestPass.status)"
            (click)="handleRemove()">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
